import { ResearchHub } from '../components/ResearchHub';

export default function ResearchPage({ role }) {
  const userId = localStorage.getItem('userId');
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          {/* <h1 className="text-3xl font-semibold">Research Hub</h1>
          <p className="text-muted-foreground mt-1">
            Access market research, reports, and analysis
          </p> */}
        </div>
      </div>
      <ResearchHub userRole={role} userId={userId} />
    </div>
  );
}
